export default __webpack_public_path__ + "2d37c6dc673be7b1b845139119deb3b6.svg";